import getRequest from '@helpers/api/get';
import putRequest from '@helpers/api/put';

/**
 * @typedef {Object} Token
 * @property {string} status
 * @property {string} token
 * @property {string} need2faSetup
 * @property {string} isTestAccount
 * @property {User} user
 */

/**
 * user signup request
 * @param payload
 * @returns {Promise<*|Token>}
 */
export const userSignupRequest = payload => putRequest(`auth/user/${payload?.id}/`, payload);

/**
 * verify invitation request
 * @param token
 * @returns {Promise<*>}
 */
export const verifyInvitationRequest = token => getRequest(`auth/userInvitationValid/${token}/`);
